import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { UserTask } from './user-task';
export { UserTask };
import { userTaskSchema } from '@schemas/business-objects/user-task';
import { RoleFormGroup } from './role-form-group';
import { TokenFormArray, TokenFormGroup } from './token-form-group';
import { UserFormGroup } from './user-form-group';
import { UserTaskHistoryFormArray } from './user-task-history-form-group';

export class UserTaskFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    referenceNumber: SchemaFormControl;
    name: SchemaFormControl;
    status: SchemaFormControl;
    data: SchemaFormControl;
    completedAt: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    tokenId: SchemaFormControl;
    token: TokenFormGroup;
    roleId: SchemaFormControl;
    role: RoleFormGroup;
    userId: SchemaFormControl;
    user: UserFormGroup;
    tokens: TokenFormArray;
    userTaskHistories: UserTaskHistoryFormArray;
  };

  declare value: Partial<UserTask>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(userTaskSchema, UserTask, data, options);
  }

  get object(): UserTask {
    return new UserTask(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'token':
        return new TokenFormGroup();
      case 'role':
        return new RoleFormGroup();
      case 'user':
        return new UserFormGroup();
      case 'tokens':
        return new TokenFormArray();
      case 'userTaskHistories':
        return new UserTaskHistoryFormArray();
      default:
        return undefined;
    }
  }

  async updateData(options: any): Promise<any> {
    const instance = new UserTask(this.value);
    return instance.updateData(options);
  }

  async unclaim(): Promise<any> {
    const instance = new UserTask(this.value);
    return instance.unclaim();
  }

  async reassign(userId: number): Promise<any> {
    const instance = new UserTask(this.value);
    return instance.reassign(userId);
  }

  async complete(options: any): Promise<any> {
    const instance = new UserTask(this.value);
    return instance.complete(options);
  }

  async claim(userId?: number): Promise<any> {
    const instance = new UserTask(this.value);
    return instance.claim(userId);
  }
}

export class UserTaskFormArray extends PersistedFormArray {
  readonly entityName = 'UserTask' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(userTaskSchema, UserTask, options);
  }

  protected override createItemGroup() {
    return new UserTaskFormGroup();
  }

  get array(): UserTask[] {
    return this.controls.map((group: UserTaskFormGroup) => group.object);
  }
}

export class UserTaskPersistedArray extends PersistedArray<UserTask> {
  readonly entityName = 'UserTask' as const;

  constructor(options?: PersistedArrayOptions) {
    super(UserTask, options);
  }
}
